import { combineReducers } from 'redux'

import sncDialogState from './sncDialogState'

export default combineReducers({
  sncDialogState,
})
